import { CssBaseline } from '@mui/material'
import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import { Provider } from 'react-redux'
import App from './App'
import { store } from './redux/store'
import reportWebVitals from './reportWebVitals'
// import { GoogleOAuthProvider } from '@react-oauth/google'
import { ThemeProvider, createTheme } from '@mui/material/styles'

const root = ReactDOM.createRoot(document.getElementById('root'))
const themeOptions = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: 'rgb(23, 60, 87)',
    },
    secondary: {
      main: 'rgb(73, 88, 103)',
    },
    otherColor: {
      main: 'rgb(27, 57, 90)',
    },
  },
  components: {
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: 'rgb(23, 60, 87)',
          color: 'white',
        },
      },
    },
  },
})
root.render(
  <React.StrictMode>
    <ThemeProvider theme={themeOptions}>
      <Provider store={store}>
        <CssBaseline />
        <App />
      </Provider>
    </ThemeProvider>
  </React.StrictMode>,
)
reportWebVitals()
